import React from 'react';
import classnames from 'classnames';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import TextRenderer from '../../../../TextRenderer';
import { LongStatusViewer } from '../../../../DaEditorWrapper/Viewer/Status';
import draftTheme from '../../../../DaEditorWrapper/Themes/Viewer/feedcard.scss';
import legacyTheme from '../../feedcard.legacy.theme.scss';
import s from './LongStatus.scss';
const LongStatusFeedCardContents = ({ deviation  })=>{
    const { tier  } = useSubscriptionTier(deviation);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, !!tier && /*#__PURE__*/ React.createElement(PromoBadge, {
        badgeType: "tier",
        size: 40,
        className: s['tier-badge']
    }), /*#__PURE__*/ React.createElement(TextRenderer, {
        textContent: deviation.textContent,
        reactViewer: LongStatusViewer,
        viewerKey: deviation.deviationId,
        legacyTheme: "status",
        fixedParagraph: false,
        disableLazyLoading: true,
        draftjsThemeOverride: draftTheme,
        className: classnames(s['content'], legacyTheme['legacy'], legacyTheme['override'], draftTheme['override'])
    }));
};
LongStatusFeedCardContents.displayName = 'LongStatusFeedCardContents';
export default LongStatusFeedCardContents;
